/*
 * Copyright 1999-2024 Jagex Ltd.
 */
export enum UserType {
  Jagex = 'JAGEX',
  FirstParty = 'FIRST_PARTY'
}

export type UserAccountTypeInfo = {
  type: UserType;
  hasRSAccount: boolean;
  runescapeId?: string;
};

export type UserAccountInfo = {
  emailExists: boolean;
  parentId: string;
  displayName: string;
};

export type UserAccountSelectionResponse = { RSAccountsSelectUrl?: string };

export type UserAccountInfoResponse = UserAccountInfo;
